import { render, staticRenderFns } from "./RequestUpdateModal.vue?vue&type=template&id=5b9d9f8b&scoped=true"
import script from "./RequestUpdateModal.vue?vue&type=script&lang=js"
export * from "./RequestUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./RequestUpdateModal.vue?vue&type=style&index=0&id=5b9d9f8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d9f8b",
  null
  
)

export default component.exports